var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{ref:"overlay",staticClass:"fixed w-full h-full top-0 left-0 overflow-hidden",style:({height: _vm.winH + 'px', background: _vm.settings.bgColor, cursor: 'wait' })},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }